const CRYPTO_COMPARE_URI = "https://min-api.cryptocompare.com/data/";
const COIN_CAP_WS_URI = "wss://ws.coincap.io/";
const COIN_CAP_URI = "https://api.coincap.io/v2/";
const CRYPTO_COMPARE_API_KEY =
  "0ffd426e05f6800fd35e540bcc7d3199a05b7993d7acb6e45144c11adfde6393";

export {
  CRYPTO_COMPARE_URI,
  COIN_CAP_URI,
  COIN_CAP_WS_URI,
  CRYPTO_COMPARE_API_KEY,
};
